module.exports = __webpack_public_path__ + "static/PalmOil-457334c60c5c170a6ce9b26ce891c27f.webp";